<script setup>
import PageRefactored from './components/PageRefactored.vue';
</script>

<template>
  <PageRefactored />
</template>

<style scoped>

</style>
